<template>
	<div class="acb">
		<div class="btn-action"
			v-html="label"
			:class="{active: active}"
			@click="$emit('input', name)"
			></div>
	</div>
</template>

<script>
export default {
	name: "ActionBtn",
	props: {
		value: String,
		name: String,
		label: String
	},
	data() {
		return {
			active: false
		}
	},
	watch: {
		value(n) {
			if (n === this.name)
				this.active = true
			else
				this.active = false

			return n
		}
	}
}
</script>
